import { ReactComponent as StatusQueuedSVG } from '../assets/images/status-queued.svg';

const StatusQueued = () => {
  return <StatusQueuedSVG className="text-light-grey" />;
}

export default StatusQueued;
